import { render } from "./HuggingChatBotSettings.vue?vue&type=template&id=2957c662"
import script from "./HuggingChatBotSettings.vue?vue&type=script&lang=js"
export * from "./HuggingChatBotSettings.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__